import script from "./HTMazeGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTMazeGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTMazeGamePlay.vue?vue&type=style&index=0&id=cc9d50d4&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc9d50d4"]])

export default __exports__